import { createSelector } from 'reselect'

export const getRecords = (state) => state.pusher.records
export const getMeta = (state) => state.pusher.meta

export const getTopics = createSelector(getRecords, (records = {}) => Object.values(records))

export const getStatus = createSelector(getMeta, (meta = {}) => meta.status)
